import React, { useEffect } from 'react';
import { IconCopy } from '@bynder/icons';
import useEditor from 'packages/hooks/useEditor';
import useForceUpdate from 'packages/hooks/useForceUpdate';
import generateTestId from 'packages/helpers/testIdHelpers';
import { TimelineActionsIcon } from 'packages/common/editor/timeline/timeline-actions/TimelineActions.styled';
import useGeneralShortcuts from 'packages/hooks/shortcuts/useGeneralShortcuts';
import useElementGeneralActions from 'packages/pages/editor/useElementGeneralActions';
import { parseShortcutForTooltip } from 'packages/common/WithShortcutLabel';

const testId = generateTestId('timeline_actions_duplicate');

export default function DuplicateAction() {
    const { manipulationRenderer } = useEditor();
    const forceUpdate = useForceUpdate();
    const { handleDuplicate } = useElementGeneralActions();

    const selectedElements = manipulationRenderer?.getSelectedElements() || [];
    const isActive = !!selectedElements.length;

    useGeneralShortcuts({ handleDuplicate });

    useEffect(() => {
        if (!manipulationRenderer) {
            return;
        }

        manipulationRenderer.eventEmitter.on('elementSelected', forceUpdate);

        return () => {
            manipulationRenderer.eventEmitter.off('elementSelected', forceUpdate);
        };
    }, [forceUpdate, manipulationRenderer]);

    return (
        <div title={`Duplicate (${parseShortcutForTooltip(['cmd', 'd'])})`}>
            <TimelineActionsIcon onClick={handleDuplicate} active={isActive} {...testId}>
                <IconCopy />
            </TimelineActionsIcon>
        </div>
    );
}
